import { Inject, Injectable, InjectionToken } from '@angular/core';
import { PaginatedState, PaginatedStateLoadingMode, PaginatedStateModel } from '@shared/ui';
import { MethodTypeKind } from '@protocols/use-cases';

export interface MethodTypeItem {
  id: string;
  name: string;
  type?: MethodTypeKind;
  usedByCaseTypes?: number; // undefined = not loaded yet
  usedBySamples?: number; // undefined = not loaded yet
  /** True for staged rows that exist only client-side (not yet persisted). */
  pending?: boolean;
}

export type MethodTypeListStateModel = PaginatedStateModel<MethodTypeItem>;

export const METHOD_TYPE_LIST_PAGINATION_MODE = new InjectionToken<PaginatedStateLoadingMode>(
  'METHOD_TYPE_LIST_PAGINATION_MODE'
);

@Injectable()
export class MethodTypeListState extends PaginatedState<MethodTypeItem, MethodTypeListStateModel> {
  constructor(@Inject(METHOD_TYPE_LIST_PAGINATION_MODE) paginationMode: PaginatedStateLoadingMode) {
    super({ maxConcurrentCountQueries: 2, loadingMode: paginationMode });
  }

  // Backwards-compat alias selectors
  public readonly methodTypes$ = this.items$;
  public readonly nextMethodTypeToken$ = this.nextToken$;
  public readonly previousMethodTypeTokens$ = this.previousTokens$;
  public readonly methodTypesLoaded$ = this.itemsLoaded$;
  public readonly noMethodTypes$ = this.noItems$;
}
